export default "__VITE_ASSET__Lj7Fr7QZ__"